import { Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-individual-events',
  templateUrl: './individual-events.component.html',
  styleUrls: ['./individual-events.component.scss']
})
export class IndividualEventsComponent implements OnInit, OnDestroy {
  private destroy$ = new BehaviorSubject<void>(null);
  constructor() { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
